import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledAdministrationIntervalSelect = styled(Select)`
   width: 140px;
` as typeof Select;
